import { render, staticRenderFns } from "./CdFinalForm.vue?vue&type=template&id=52c4c7d2&scoped=true&"
import script from "./CdFinalForm.vue?vue&type=script&lang=js&"
export * from "./CdFinalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4c7d2",
  null
  
)

export default component.exports